var _g, _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadDocWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_819_10154)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#BA7DE9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 9,
    height: 8,
    fill: "#A461D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.0502H20.5L17.87 10.8702C17.7769 10.7555 17.6596 10.6628 17.5265 10.5988C17.3934 10.5348 17.2477 10.5012 17.1 10.5002H12.5C11.8466 10.4922 11.2167 10.7434 10.7481 11.1988C10.2795 11.6543 10.0105 12.2768 10 12.9302V25.0702C10.0105 25.7235 10.2795 26.3461 10.7481 26.8015C11.2167 27.257 11.8466 27.5082 12.5 27.5002H27.5C28.1534 27.5082 28.7833 27.257 29.2519 26.8015C29.7205 26.3461 29.9895 25.7235 30 25.0702V16.4802C29.9895 15.8268 29.7205 15.2043 29.2519 14.7488C28.7833 14.2934 28.1534 14.0422 27.5 14.0502ZM22 22.0002H21V23.0002C21 23.2654 20.8946 23.5198 20.7071 23.7073C20.5196 23.8948 20.2652 24.0002 20 24.0002C19.7348 24.0002 19.4804 23.8948 19.2929 23.7073C19.1054 23.5198 19 23.2654 19 23.0002V22.0002H18C17.7348 22.0002 17.4804 21.8948 17.2929 21.7073C17.1054 21.5198 17 21.2654 17 21.0002C17 20.735 17.1054 20.4806 17.2929 20.2931C17.4804 20.1055 17.7348 20.0002 18 20.0002H19V19.0002C19 18.735 19.1054 18.4806 19.2929 18.2931C19.4804 18.1055 19.7348 18.0002 20 18.0002C20.2652 18.0002 20.5196 18.1055 20.7071 18.2931C20.8946 18.4806 21 18.735 21 19.0002V20.0002H22C22.2652 20.0002 22.5196 20.1055 22.7071 20.2931C22.8946 20.4806 23 20.735 23 21.0002C23 21.2654 22.8946 21.5198 22.7071 21.7073C22.5196 21.8948 22.2652 22.0002 22 22.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10 11.6193 11.1193 10.5 12.5 10.5H17.1344C17.4358 10.5 17.7212 10.636 17.9111 10.8701L20.4498 14H10V13Z",
    fill: "#A461D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_819_10154",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_819_10154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_819_10154",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocWhite);
export default __webpack_public_path__ + "static/media/upload-doc-white.43185da170c9e849d4654d2f86113cab.svg";
export { ForwardRef as ReactComponent };